<template>
	<ui-modal title=" Excluir Equipe" name="delete-team-modal" icon="fal fa-trash-alt" size="xs">
		<div class="modal-content-line">
			<p>
				Para excluir você precisa selecionar uma equipe que receberá os usuários de  <span class="color-primary">{{labelComputed}}</span>.
			</p>
		</div>

		<form class="modal-content-line form">
			<ui-select-2
				v-model="team"
				:data="teams"
				:multiple="false"
				:loading="layout.loader"
				item-label="name"
				label="Equipes:"
				size="md"

				@input="disableButton($event)"
			/>
		</form>

		<div class="modal-content-line alert">
			<strong>Atenção</strong>
			<div>Ao confirmar a exclusão do equipe esta ação não poderá ser desfeita.</div>
		</div>

		<template #footer>
			<ui-button design="md link" @click="close">Cancelar</ui-button>
			<ui-button design="md danger" @click="confirm" :disabled="layout.isDisableSubmit">
				Confirmar Exclusão
			</ui-button>
		</template>
	</ui-modal>
</template>
<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiSelect2 } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'

	import { team } from '@/services/axios'

	export default {
		components: {
			uiModal,
			uiSelect2,
			uiButton,
		},

		data(){
			return {
				data: {},
				layout: {
					isDisableSubmit: true,
					loader: false
				},
				team: {},
				teams: []
			}
		},

        props: {},

        computed: {
            labelComputed(){
                return this.data.name
            }
        },

		created(){
			this.$root.$on('modal-open-delete-team-modal', async (data) => {
				this.data = data
				this.getTeams()
				// console.log('Response', '=>', data)
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-delete-team-modal')
		},

		methods: {
			close() {
				this.$root.$emit('modal-close-delete-team-modal')
			},

			confirm(){
				this.layout.loader = true
				team
					.delete(this.data.id, this.team.id)
					.then((response) => {
						if (response.data && response.data.status !== 'error') {
							this.$toastr.s(response.data.msg)
						}else { 
							this.$toastr.e(response.data.msg)
						}
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						this.layout.loader = false
						this.close()
						this.$root.$emit('users-teams-search', '')
					})
			},

			getTeams(){
				this.layout.loader = true
				team
					.getAll('search', { nocover: true, per_page: 1000 })
					.then((response) => {
						if (response.data && response.data.status !== 'error') {
							/**
							* Filtra a @param {Object} response da chamada getAll,  
							* criando um novo array sem
							* o item que possuir o mesmo @param {String} this.data.id
							* da equipe que está sendo deletada.
							**/
							this.teams = response.data.data.filter((newTeam) => newTeam.id != this.data.id)
						}else { 
							this.$toastr.e(response.data.msg)
						}
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						this.layout.loader = false
					})
			},

			disableButton(value){
				this.layout.isDisableSubmit = true

				if (value && value.id) {
					this.layout.isDisableSubmit = false
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
